<template>
    <div class="container-fluid">

        <!-- search window -->
        <div class="row search-bg">
            <div class="col-12 text-center pt-4">
                <h4>What item are you looking for?</h4>
                <!-- import search box -->
                <div class="offset-md-2 col-md-8 col-sm-12 px-0">
                    <app-search></app-search>
                </div>
            </div>
        </div>

        <!-- category icons -->
        <app-icons></app-icons>

        <!-- additional bottom space -->
        <div class="my-5">&nbsp;</div>
        
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import Search from '../Search.vue'
import Icons from './Icons.vue'

export default {
    name: 'Splash',
    methods: {
        ...mapActions(['showHeaderSearchBarAction']),
        hideHomeSearchFxn() {
            this.showHeaderSearchBarAction(false).then(() => {}).catch((e) => {})
        },
        showHomeSearchFxn() {
            this.showHeaderSearchBarAction(true).then(() => {}).catch((e) => {})
        }
    },
    components: {
        appSearch: Search,
        appIcons: Icons
    },
    destroyed(){
        this.showHomeSearchFxn()
    },
    mounted() {
        this.hideHomeSearchFxn()
    }
}
</script>